// src/features/editor/components/EditorHeader/HeaderRightCluster.tsx
import { SaveStatusIndicator } from './SaveStatusIndicator'
import { PublishButton } from './PublishButton'

interface Props {
  courseId: number
  isCourseAuthor: boolean
}

/** Right header cluster: cloud save status · publish (предпросмотр скрыт). Чип баланса — слева,
 *  рядом с выбором языка (`HeaderToolsGroup`). */
export const HeaderRightCluster = ({ courseId, isCourseAuthor }: Props) => (
  <div className="ml-4 flex shrink-0 items-center gap-1 sm:ml-16 sm:gap-2">
    {/* Уже `lg` облачко живёт в баре над уроками (`MobileTimelineBar`). */}
    <div className="hidden lg:block">
      <SaveStatusIndicator />
    </div>
    {/* «Пройти курс как ученик» (`PreviewButton`) временно скрыта по просьбе
        заказчика — сам предпросмотр и кнопка в коде остались. */}
    <PublishButton courseId={courseId} isCourseAuthor={isCourseAuthor} />
  </div>
)
